import {  EmptyObservable  } from './EmptyObservable';

export const empty = EmptyObservable.create;


// WEBPACK FOOTER //
// ./~/rxjs/src/observable/empty.ts